import { observable, action, computed, makeObservable } from 'mobx';
import apiActions from '../../api/actions';

export default class MessageStore {
  constructor(root) {
    makeObservable(this, {
      data: observable,
      requests: observable,
      add: action,
      addMany: action,
      remove: action,
      all: computed,
      reset: action,
      fetchAll: action,
      refetch: action,
      fetchAllCompleted: computed,
      length: computed,
      unread: computed,
      unreadCount: computed
    });

    this.root = root;
  }

  data = new Map();
  requests = new Map();

  add = (data) => {
    const message = new Message(data, this.root);
    this.data.set(message.id, message);
  }

  addMany = (datas) => {
    const merge = new Map();
    datas.forEach(data => {
      const message = new Message(data, this.root);
      merge.set(message.id, message);
    });
    this.data.merge(merge);
  }

  remove = (id) => {
    if (id && this.data.has(id)) this.data.delete(id);
  }

  find(id) {
    return this.data.get(id);
  }

  reset = () => {
    this.data.clear();
    this.requests.clear();
  }

  fetchAll() {
    if (this.requests.get('all') === undefined) {
      this.requests.set('all', 'pending');
      return apiActions.index('messages').then((response) => {
        this.addMany(response.data);
        this.requests.set('all', 'complete');
      });
    }
    return Promise.resolve();
  }

  refetch() {
    if (this.requests.get('all') !== undefined) {
      this.reset();
      return this.fetchAll();
    }
    this.reset();
    return Promise.resolve();
  }

  get fetchAllCompleted() {
    return this.requests.get('all') === 'complete';
  }

  get all() {
    return Array.from(this.data.values());
  }

  get length() {
    return this.all.length;
  }

  get unread() {
    return this.all.filter(m => !m.read);
  }

  get unreadCount() {
    return this.unread.length;
  }
}

export class Message {
  constructor(data, root) {
    this._root = root;
    this.body = data.body;
    this.created_at = data.created_at;
    this.id = data.id;
    this.message_type = data.message_type;
    this.read = data.read;
    this.subject = data.subject;
    this.updated_at = data.updated_at;
    this.user_id = data.user_id;
  }
}
